/* =============================================================================
   Brandable — theme behaviour
   Vanilla, no dependencies, no build step. Everything is wired through data-
   attributes so markup can be restyled without touching this file.
   ========================================================================== */
(function () {
  'use strict';

  var on = function (el, ev, fn) { el && el.addEventListener(ev, fn); };
  var $  = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* --- Money -------------------------------------------------------------
     Mirrors Shopify's money_format placeholders so prices rendered by JS match
     prices rendered by Liquid.
     -------------------------------------------------------------------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var fmt = format || '${{amount}}';

    function num(number, precision, thousands, decimal) {
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cts = parts[1] ? decimal + parts[1] : '';
      return dollars + cts;
    }

    switch ((fmt.match(placeholder) || [])[1]) {
      case 'amount':                     value = num(cents, 2, ',', '.'); break;
      case 'amount_no_decimals':         value = num(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator':value = num(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = num(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = num(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = num(cents, 0, ' ', ','); break;
      case 'amount_with_space_separator': value = num(cents, 2, ' ', ','); break;
      default:                            value = num(cents, 2, ',', '.');
    }
    return fmt.replace(placeholder, value);
  }

  /* --- Announcement bar ------------------------------------------------- */
  (function announcement() {
    var bar = $('[data-announcement]');
    if (!bar) return;
    try {
      if (sessionStorage.getItem('announcement-dismissed') === '1') { bar.hidden = true; return; }
    } catch (e) {}
    on($('[data-announcement-close]', bar), 'click', function () {
      bar.hidden = true;
      try { sessionStorage.setItem('announcement-dismissed', '1'); } catch (e) {}
    });
  })();

  /* --- Drawers ---------------------------------------------------------- */
  (function drawers() {
    var openDrawer = null;

    function close() {
      if (!openDrawer) return;
      openDrawer.classList.remove('is-open');
      document.body.classList.remove('no-scroll');
      openDrawer = null;
    }

    $$('[data-drawer-open]').forEach(function (btn) {
      on(btn, 'click', function () {
        var target = document.getElementById(btn.getAttribute('data-drawer-open'));
        if (!target) return;
        close();
        openDrawer = target;
        target.classList.add('is-open');
        document.body.classList.add('no-scroll');
        var focusable = target.querySelector('input, a, button');
        if (focusable) focusable.focus();
      });
    });

    $$('[data-drawer-close]').forEach(function (el) { on(el, 'click', close); });
    on(document, 'keydown', function (e) { if (e.key === 'Escape') close(); });
  })();

  /* --- Horizontal carousels --------------------------------------------- */
  $$('[data-carousel]').forEach(function (root) {
    var track = $('[data-carousel-track]', root);
    if (!track) return;
    function step(dir) {
      var card = track.firstElementChild;
      var amount = card ? card.getBoundingClientRect().width + 20 : track.clientWidth * 0.8;
      track.scrollBy({ left: dir * amount, behavior: 'smooth' });
    }
    on($('[data-carousel-prev]', root), 'click', function () { step(-1); });
    on($('[data-carousel-next]', root), 'click', function () { step(1); });
  });

  /* --- Quantity steppers (product form) --------------------------------- */
  $$('[data-qty]').forEach(function (btn) {
    on(btn, 'click', function () {
      var input = $('input', btn.parentNode);
      if (!input) return;
      var next = (parseInt(input.value, 10) || 1) + parseInt(btn.getAttribute('data-qty'), 10);
      input.value = Math.max(parseInt(input.min, 10) || 1, next);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  /* --- Product page ------------------------------------------------------ */
  (function product() {
    var root = $('[data-product-root]');
    if (!root) return;

    /* Gallery */
    var main = $('[data-main-media] img', root);
    $$('[data-thumb]', root).forEach(function (thumb) {
      on(thumb, 'click', function () {
        var img = $('img', thumb);
        if (!img || !main) return;
        main.src = thumb.getAttribute('data-full') || img.src;
        main.removeAttribute('srcset');
        main.alt = img.alt;
        $$('[data-thumb]', root).forEach(function (t) { t.setAttribute('aria-current', 'false'); });
        thumb.setAttribute('aria-current', 'true');
      });
    });

    /* Variants */
    var dataEl = $('[data-variant-data]', root);
    if (!dataEl) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var idInput   = $('[data-variant-id]', root);
    var priceEl   = $('[data-price]', root);
    var addBtn    = $('[data-add-to-cart]', root);
    var addLabel  = $('[data-add-label]', root);
    var moneyFmt  = root.getAttribute('data-money-format');
    var strings   = {
      add:      addBtn ? addBtn.getAttribute('data-add-text')      : 'Add to Cart',
      soldOut:  addBtn ? addBtn.getAttribute('data-sold-out-text') : 'Sold out',
      unavail:  addBtn ? addBtn.getAttribute('data-unavailable-text') : 'Unavailable'
    };

    function selectedOptions() {
      var chosen = [];
      $$('[data-option-selector]', root).forEach(function (input) {
        if (input.checked) chosen[parseInt(input.getAttribute('data-position'), 10) - 1] = input.value;
      });
      return chosen;
    }

    function matchVariant(chosen) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var ok = true;
        for (var j = 0; j < chosen.length; j++) {
          if (chosen[j] != null && v.options[j] !== chosen[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    function renderPrice(variant) {
      if (!priceEl) return;
      var html = '<span>' + formatMoney(variant.price, moneyFmt) + '</span>';
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        html += '<s class="price__compare">' + formatMoney(variant.compare_at_price, moneyFmt) + '</s>';
        var off = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
        html += '<span class="badge-discount">-' + off + '%</span>';
      }
      priceEl.innerHTML = html;
    }

    function update() {
      var variant = matchVariant(selectedOptions());

      if (!variant) {
        if (addBtn) { addBtn.disabled = true; }
        if (addLabel) addLabel.textContent = strings.unavail;
        return;
      }

      if (idInput) idInput.value = variant.id;
      renderPrice(variant);

      if (addBtn) addBtn.disabled = !variant.available;
      if (addLabel) addLabel.textContent = variant.available ? strings.add : strings.soldOut;

      /* Keep the URL shareable without reloading. */
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }

      /* Swap the main image to the variant's own image when it has one. */
      if (variant.featured_image && main) {
        main.src = variant.featured_image.src;
        main.removeAttribute('srcset');
      }
    }

    $$('[data-option-selector]', root).forEach(function (input) { on(input, 'change', update); });
  })();

  /* --- Product tabs ------------------------------------------------------ */
  $$('[data-tabs]').forEach(function (root) {
    var tabs = $$('[data-tab]', root);
    tabs.forEach(function (tab) {
      on(tab, 'click', function () {
        tabs.forEach(function (t) {
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          var active = t === tab;
          t.setAttribute('aria-selected', active ? 'true' : 'false');
          if (panel) panel.hidden = !active;
        });
      });
    });

    /* If a reviews app injected content, drop our placeholder note. */
    var container = $('#shopify-product-reviews', root);
    var empty = $('[data-reviews-empty]', root);
    if (container && empty) {
      var check = function () { if (container.children.length > 0) empty.hidden = true; };
      check();
      new MutationObserver(check).observe(container, { childList: true, subtree: true });
    }
  });

  /* --- Related products (Recommendations API) ---------------------------- */
  (function recommendations() {
    var el = $('[data-recommendations]');
    if (!el || !el.dataset.url) return;
    fetch(el.dataset.url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
      })
      .catch(function () { /* leave the section empty */ });
  })();

  /* --- Cart -------------------------------------------------------------- */
  (function cart() {
    var form = $('[data-cart-form]');
    if (!form) return;

    $$('[data-cart-qty]', form).forEach(function (btn) {
      on(btn, 'click', function () {
        var input = $('[data-cart-qty-input]', btn.parentNode);
        if (!input) return;
        var next = (parseInt(input.value, 10) || 0) + parseInt(btn.getAttribute('data-cart-qty'), 10);
        input.value = Math.max(0, next);
        form.submit();
      });
    });

    /* Shopify applies discount codes at checkout. /discount/CODE stores the
       code against the session and bounces back, so the cart totals and the
       checkout both reflect it. */
    var apply = $('[data-promo-apply]', form);
    var code  = $('[data-promo-code]', form);
    on(apply, 'click', function () {
      var value = (code.value || '').trim();
      if (!value) { code.focus(); return; }
      window.location.href = '/discount/' + encodeURIComponent(value) + '?redirect=/cart';
    });
    on(code, 'keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); apply.click(); } });
  })();

  /* --- Collection filters + sort ----------------------------------------- */
  (function collection() {
    var form = $('[data-filter-form]');
    var sort = $('[data-sort-by]');

    function go(params) {
      var url = new URL(window.location.href);
      url.search = params.toString();
      window.location.href = url.toString();
    }

    if (form) {
      on(form, 'submit', function (e) {
        e.preventDefault();
        var params = new URLSearchParams();
        $$('input', form).forEach(function (input) {
          if (input.type === 'checkbox' && input.checked) params.append(input.name, input.value);
          if (input.type === 'number' && input.value !== '') params.append(input.name, input.value);
        });
        if (sort && sort.value) params.set('sort_by', sort.value);
        go(params);
      });
    }

    if (sort) {
      on(sort, 'change', function () {
        var params = new URLSearchParams(window.location.search);
        params.set('sort_by', sort.value);
        params.delete('page');
        go(params);
      });
    }
  })();
})();
